/*
 * @Descripttion: 
 * @version: 
 * @Author: wl
 * @Date: 2020-08-22 14:56:17
 * @LastEditors: wl
 * @LastEditTime: 2020-08-22 14:56:54
 */
import axios from '../axios'
// 预警类型  strategy_type_list
export const handleQuery = (data) => {
    return axios({
        url: '/admin/service/data_push_log',
        method: 'post',
        data
    })
}

// 账号管理  新增
export const pushAccount_add = (data) => {
    return axios({
        url: '/admin/service/data_pushAccount_add',
        method: 'post',
        data
    })
}

// 账号管理 列表
// data_pushAccount_list
export const pushAccount_list = (data) => {
    return axios({
        url: '/admin/service/data_pushAccount_list',
        method: 'post',
        data
    })
}

// 点位管理 小区是否开启
export const community_open = (data) => {
    return axios({
        url: '/admin/service/sys_community_open',
        method: 'post',
        data
    })
}

// 一键注册
// sys_community_apply
export const community_apply = (data) => {
    return axios({
        url: '/admin/service/sys_community_apply',
        method: 'post',
        data
    })
}
// 麦斯
export const maisi = (data) => {
    return axios({
        url: '/admin/service/data_pushMaiSi_log',
        method: 'post',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/social.js